// VARIABLES
// elements for mobile menu
const $005843ec607c9454$var$menuButton = document.querySelector("#menu-button");
const $005843ec607c9454$var$menu = document.querySelector("#menu");
const $005843ec607c9454$var$classOpen = "open";
// interactive elements for scroll to
const $005843ec607c9454$var$toStartElements = document.querySelectorAll(".to-start");
const $005843ec607c9454$var$toEventElement = document.querySelector("#to-event");
const $005843ec607c9454$var$toAboutElement = document.querySelector("#to-about");
const $005843ec607c9454$var$toFaqsElement = document.querySelector("#to-faqs");
const $005843ec607c9454$var$toCodeOfConductElement = document.querySelector("#to-code-of-conduct");
const $005843ec607c9454$var$toContactElements = document.querySelectorAll(".to-contact");
// elements to be scrolled to
const $005843ec607c9454$var$eventElement = document.querySelector("#proximos-eventos");
const $005843ec607c9454$var$aboutElement = document.querySelector("#quienes-somos");
const $005843ec607c9454$var$faqsElement = document.querySelector("#preguntas-frecuentes");
const $005843ec607c9454$var$codeOfConductElement = document.querySelector("#codigo-de-conducta");
const $005843ec607c9454$var$contactElement = document.querySelector("#contacto");
// constants and variables for header changes on scroll
const $005843ec607c9454$var$header = document.querySelector("#header");
const $005843ec607c9454$var$hero = document.querySelector("#inicio");
let $005843ec607c9454$var$heroHeight = $005843ec607c9454$var$hero.scrollHeight - $005843ec607c9454$var$header.scrollHeight;
let $005843ec607c9454$var$oldScrollValue = 0;
let $005843ec607c9454$var$newScrollValue = window.pageYOffset;
const $005843ec607c9454$var$classMain = "main";
const $005843ec607c9454$var$classHidden = "hidden";
const $005843ec607c9454$var$lockBodyScroll = "body-scroll-lock";
// FUNCTIONS
// Open / close mobile menu
function $005843ec607c9454$var$toggleMenu() {
    if ($005843ec607c9454$var$menuButton.classList.contains($005843ec607c9454$var$classOpen)) {
        $005843ec607c9454$var$closeMenu();
        document.body.classList.remove($005843ec607c9454$var$lockBodyScroll);
    } else {
        $005843ec607c9454$var$menuButton.classList.add($005843ec607c9454$var$classOpen);
        $005843ec607c9454$var$menu.classList.add($005843ec607c9454$var$classOpen);
        document.body.classList.add($005843ec607c9454$var$lockBodyScroll);
    }
}
function $005843ec607c9454$var$closeMenu() {
    $005843ec607c9454$var$menuButton.classList.remove($005843ec607c9454$var$classOpen);
    $005843ec607c9454$var$menu.classList.remove($005843ec607c9454$var$classOpen);
    document.body.classList.remove($005843ec607c9454$var$lockBodyScroll);
}
// Smooth scroll to
function $005843ec607c9454$var$scrollToElement(el, e) {
    e.preventDefault();
    el.scrollIntoView({
        behavior: "smooth"
    });
}
// EVENTS
// event for open / close menu
$005843ec607c9454$var$menuButton.addEventListener("click", $005843ec607c9454$var$toggleMenu);
$005843ec607c9454$var$menu.addEventListener("click", $005843ec607c9454$var$closeMenu);
// Scroll events
$005843ec607c9454$var$toStartElements.forEach((i)=>{
    i.addEventListener("click", (e)=>{
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
});
$005843ec607c9454$var$toEventElement.addEventListener("click", (e)=>{
    $005843ec607c9454$var$scrollToElement($005843ec607c9454$var$eventElement, e);
});
$005843ec607c9454$var$toAboutElement.addEventListener("click", (e)=>{
    $005843ec607c9454$var$scrollToElement($005843ec607c9454$var$aboutElement, e);
});
$005843ec607c9454$var$toFaqsElement.addEventListener("click", (e)=>{
    $005843ec607c9454$var$scrollToElement($005843ec607c9454$var$faqsElement, e);
});
$005843ec607c9454$var$toCodeOfConductElement.addEventListener("click", (e)=>{
    $005843ec607c9454$var$scrollToElement($005843ec607c9454$var$codeOfConductElement, e);
});
$005843ec607c9454$var$toContactElements.forEach((i)=>{
    i.addEventListener("click", (e)=>{
        $005843ec607c9454$var$scrollToElement($005843ec607c9454$var$contactElement, e);
    });
});
window.onscroll = ()=>{
    $005843ec607c9454$var$heroHeight = $005843ec607c9454$var$hero.scrollHeight - $005843ec607c9454$var$header.offsetHeight;
    // check position to add or remove the style to header to be visible on main content
    if (window.scrollY >= $005843ec607c9454$var$heroHeight) $005843ec607c9454$var$header.classList.add($005843ec607c9454$var$classMain);
    else $005843ec607c9454$var$header.classList.remove($005843ec607c9454$var$classMain);
    // check position to hide or show header
    if (window.scrollY >= $005843ec607c9454$var$header.offsetHeight) {
        $005843ec607c9454$var$newScrollValue = window.pageYOffset;
        if ($005843ec607c9454$var$oldScrollValue < $005843ec607c9454$var$newScrollValue) $005843ec607c9454$var$header.classList.add($005843ec607c9454$var$classHidden);
        else $005843ec607c9454$var$header.classList.remove($005843ec607c9454$var$classHidden);
        $005843ec607c9454$var$oldScrollValue = $005843ec607c9454$var$newScrollValue;
    }
};
window.onload = ()=>{
    $005843ec607c9454$var$header.classList.remove($005843ec607c9454$var$classHidden);
};


const $d07e92ee10480bf1$var$contactTitleContainer = document.querySelector("#contact-title-container");
const $d07e92ee10480bf1$var$contactTitle = document.querySelector("#contact-title");
let $d07e92ee10480bf1$var$intervalId;
function $d07e92ee10480bf1$var$startAnimation() {
    $d07e92ee10480bf1$var$addClonedElements();
    const clones = $d07e92ee10480bf1$var$numberToClone();
    // create array with positions of elements
    let translatePosition = new Array(clones + 1).fill(0);
    $d07e92ee10480bf1$var$intervalId = setInterval(createAnimation, 10);
    function createAnimation() {
        $d07e92ee10480bf1$var$contactTitleContainer.childNodes.forEach((el, i)=>{
            // update element position
            el.style.transform = `translateX(${translatePosition[i]}px)`;
            translatePosition[i] = translatePosition[i] - 1;
            if (Math.round(el.getBoundingClientRect().right) === 0) {
                // safe new position for moved element
                translatePosition[i] = Math.round($d07e92ee10480bf1$var$contactTitleContainer.childNodes[clones].getBoundingClientRect().right);
                // move first element to the end
                const element = el;
                $d07e92ee10480bf1$var$contactTitleContainer.removeChild(element);
                $d07e92ee10480bf1$var$contactTitleContainer.appendChild(element);
            }
        });
    }
}
function $d07e92ee10480bf1$var$stopInterval() {
    clearInterval($d07e92ee10480bf1$var$intervalId);
    $d07e92ee10480bf1$var$intervalId = null;
}
function $d07e92ee10480bf1$var$addClonedElements() {
    // create range of elelemnts to be cloned
    const cloneRange = $d07e92ee10480bf1$var$range(1, $d07e92ee10480bf1$var$numberToClone());
    // update container content
    $d07e92ee10480bf1$var$contactTitleContainer.replaceChildren($d07e92ee10480bf1$var$contactTitle);
    // clone elelemnts
    cloneRange.forEach((i)=>{
        const clone = $d07e92ee10480bf1$var$contactTitle.cloneNode(true);
        // add unique id for each cloned element
        clone.id = `contact-title-clone-${i}`;
        $d07e92ee10480bf1$var$contactTitleContainer.appendChild(clone);
    });
}
function $d07e92ee10480bf1$var$numberToClone() {
    // calculate number of cloned elelemnts
    return Math.ceil($d07e92ee10480bf1$var$contactTitleContainer.offsetWidth / $d07e92ee10480bf1$var$contactTitle.offsetWidth);
}
function $d07e92ee10480bf1$var$range(start, end) {
    // create range
    return new Array(end - start + 1).fill(undefined).map((_, i)=>i + start);
}
function $d07e92ee10480bf1$var$debounce(func) {
    let timer;
    return function(event) {
        if (timer) {
            clearTimeout(timer);
            $d07e92ee10480bf1$var$stopInterval();
        }
        timer = setTimeout(func, 200, event);
    };
}
window.addEventListener("resize", $d07e92ee10480bf1$var$debounce($d07e92ee10480bf1$var$startAnimation));
const $d07e92ee10480bf1$var$intersectionObserverOptions = {
    threshold: 0
};
const $d07e92ee10480bf1$var$intersectionObserverCallback = (entries)=>{
    for (const entry of entries)entry.isIntersecting && !$d07e92ee10480bf1$var$intervalId ? $d07e92ee10480bf1$var$startAnimation() : $d07e92ee10480bf1$var$stopInterval();
};
const $d07e92ee10480bf1$var$intersectionObserver = new IntersectionObserver($d07e92ee10480bf1$var$intersectionObserverCallback, $d07e92ee10480bf1$var$intersectionObserverOptions);
$d07e92ee10480bf1$var$intersectionObserver.observe($d07e92ee10480bf1$var$contactTitleContainer);


const $527e04a01c17ab99$var$conductContent = document.querySelector("#conduct-content");
const $527e04a01c17ab99$var$conductButton = document.querySelector("#conduct-read-more");
function $527e04a01c17ab99$var$toggleReadMore() {
    $527e04a01c17ab99$var$conductContent.style.height = `${$527e04a01c17ab99$var$conductContent.scrollHeight}px`;
    $527e04a01c17ab99$var$conductButton.style.opacity = 0;
    setTimeout(()=>{
        $527e04a01c17ab99$var$conductContent.removeAttribute("style");
        $527e04a01c17ab99$var$conductButton.style.display = "none";
    }, 550);
}
$527e04a01c17ab99$var$conductButton.addEventListener("click", $527e04a01c17ab99$var$toggleReadMore);




//# sourceMappingURL=index.a5c785f0.js.map
